import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import UrzadRaportPoLiniachTable from "./components/UrzadRaportPoLiniachTable";
import UrzadRaportPoLiniachSearchbox from "./components/UrzadRaportPoLiniachSearchbox";
import UrzadService from "../UrzadService";

export default class UrzadRaportPoLiniach extends Component {
    constructor(props) {
        super(props);
        this.state = {
            raport: [],
            czyByloSzukanie: false,
            setLoader: false,
        };
    }

    componentDidMount() {
    }

    onClickSzukaj(dataOd, dataDo) {
        this.setState({czyByloSzukanie: true, setLoader: true})
        UrzadService.getpUrzadDaneUlgiRaport(dataOd, dataDo).then(function (response) {
            this.setState({
                raport: Array.from(response.data, item => {
                    return {
                        odcinek: item.naz_pr_od + ' - ' + item.naz_pr_do,
                        ...item
                    }
                }), setLoader: false
            })
        }.bind(this))
    }


    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'UrzadContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/urzad', text: 'Urząd'}, {addressUrl: '/urzad/raport-linie', text: 'Raport biletów'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <UrzadRaportPoLiniachSearchbox handleClickSzukaj={(dataOd, dataDo) => this.onClickSzukaj(dataOd, dataDo)}/>
                        </Col>
                        <Col sm={12}>
                            {
                                Boolean(this.state.czyByloSzukanie) ?
                                    Boolean(this.state.setLoader) ?
                                        <div id={'simple-small-loader'}>
                                            <i className={'fa fa-spinner fa-spin'}></i>
                                        </div>
                                        :
                                        <UrzadRaportPoLiniachTable data={this.state.raport}/>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/urzadModule/raport_sprzedazy_po_liniach/UrzadRaportPoLiniach.js